import { useState } from 'react';

const gglUrl = 'https://www.googleapis.com/books/v1';
const libNameUrl = "https://libweb.city.setagaya.tokyo.jp/detailresult?3&target1=1&item1=AB&comp1=3&cond=1&sort=1&mv=20&buncomp=1&trguser&retresult=page&key1=";
//%25E7%25A5%2596%25E5%2585%2588%25E3%2581%25AB%25E4%25BC%259A%25E3%2581%2584%25E3%2581%25AB%25E8%25A1%258C%25E3%2581%258F";

const useSearch = () => {

  const [items, setItems] = useState([]);
  const [value, setValue] = useState("");

  const handleNewBooks = (event) => {
    setValue(event.target.value);
  };

  const searchBooks = async (event) => {
    event.preventDefault();
    if (value === '') return;
    const endpoint = gglUrl;
    const res = await fetch(`${endpoint}/volumes?q=${value}`);
    const data = await res.json();
    console.log(data);
    const dataFormat = data.items.map(item => {
      const Info = item.volumeInfo;
      return {
        title: Info.title,
        description: Info.description,
        link: Info.infoLink,
        image: Info.imageLinks ? Info.imageLinks.smallThumbnail : '',
      };
    });
    setItems(dataFormat);
  }

  return {handleNewBooks,searchBooks,items,value}

}
export default useSearch;
